<template>
  <v-card class="mx-auto" max-width="2000">
    <iframe id="credentials-frame" ref="credentials-frame" title="Credentials" :src="keycloakUrl" width="100%" height="1080px" style="border-width: 0"></iframe>
  </v-card>
</template>

<script>
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'CredentialsPage',
  created: function() {
    return this.$store.dispatch('viewMe');
  },
  computed: {
    keycloakUrl: function () {
      return new URL("/realms/" + process.env.VUE_APP_KEYCLOAK_REALM + "/account/account-security/signing-in", process.env.VUE_APP_KEYCLOAK_URL)
    }
  }
});
</script>
